import { createContext, useContext } from 'react';

/**
 * Provides the scroll container element for games impression tracking.
 * When `null` (default), listeners attach to `window`.
 */
export const ScrollContainerContext = createContext<HTMLElement | null>(null);

export function useScrollContainer(): HTMLElement | null {
  return useContext(ScrollContainerContext);
}
